/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserFavoriteGachasResponse } from '../../models/get-user-favorite-gachas-response';

export interface UserServiceGetUserFavoriteGachas$Params {
  userUuid: string;
  discordId?: string;
}

export function userServiceGetUserFavoriteGachas(http: HttpClient, rootUrl: string, params: UserServiceGetUserFavoriteGachas$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserFavoriteGachasResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUserFavoriteGachas.PATH, 'get');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.query('discordId', params.discordId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserFavoriteGachasResponse>;
    })
  );
}

userServiceGetUserFavoriteGachas.PATH = '/api/v3/gateway/user/{userUuid}/favorite/gacha';
